import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FotoGaleryDetailsPost from './FotoGaleryDetailsPost';

function FotoGaleryDetails(props) {
    const { layout } = props;

    let content;
    if (layout === 'classic') {
        content = (
            <FotoGaleryDetailsPost layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <FotoGaleryDetailsPost layout={layout} />
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

FotoGaleryDetails.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

FotoGaleryDetails.defaultProps = {
    layout: 'classic',
};
const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(FotoGaleryDetails);
